import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { StoryStat } from './success-stories.utils';

@Component({
  selector: 'app-success-stories-hero',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="cg-ss-hero" aria-labelledby="cg-ss-hero-title">
      <div class="cg-container--marketing cg-ss-hero__inner">
        @if (badge) {
          <span class="cg-ss-hero__badge">
            <span class="cg-ss-hero__badge-dot" aria-hidden="true"></span>
            {{ badge }}
          </span>
        }
        <h1 id="cg-ss-hero-title" class="cg-ss-hero__title">{{ title }}</h1>
        @if (subtitle) {
          <p class="cg-ss-hero__lede">{{ subtitle }}</p>
        }
        @if (stats.length) {
          <div class="cg-ss-hero__stats" role="list">
            @for (stat of stats; track stat.label) {
              <article class="cg-ss-hero__stat" role="listitem">
                <div class="cg-ss-hero__stat-value">{{ stat.value }}</div>
                <div class="cg-ss-hero__stat-label">{{ stat.label }}</div>
              </article>
            }
          </div>
        }
      </div>
    </section>
  `,
})
export class SuccessStoriesHeroComponent {
  @Input() badge = 'Our Global Community';
  @Input({ required: true }) title!: string;
  @Input() subtitle?: string;
  @Input() stats: StoryStat[] = [];
}
